import React, { memo } from "react";
import Root from "./routes/root";

const MainApp = () => {
  return <Root />;
};

export default memo(MainApp);
